import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHigher = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 200 200",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			d: "M13.8,96.6c1.1-5.9,4.9-9.9,8.7-14c20.4-22.2,40.7-44.4,60.9-66.7c1.6-1.8,3.1-3.6,4.8-5.1 c7.3-6.4,18-5.9,24.8,1.5c5.7,6.3,11.4,12.4,17.1,18.8c16.9,18.6,33.8,37.1,50.7,55.6c6.9,7.5,6.9,17.8-0.2,24.9 c-3.2,3.2-7.1,4.8-11.6,5c-4.8,0.2-24.6,0-29.4,0c-0.4,0-1,0-1.6,0c0,0.8,0,1.5,0,2.1c0,13.2,0,41.5,0,54.8 c0,8.4-5.7,15.4-13.8,17.4c-0.9,0.3-2,0.3-3,0.6c-24.2,0-18.5,0-42.6,0c-1-0.2-2-0.3-3-0.6c-8.2-2-13.8-8.8-13.8-17.2 c0-13.3,0-41.7,0-54.9c0-0.6,0-1.3,0-2.1c-5.5,0-25.8,0.1-31.1,0c-5.6-0.2-9.9-2.5-13.3-6.9c-1.9-2.4-2.7-5.2-3.6-8.2 C13.8,99.8,13.8,98.3,13.8,96.6z M99.9,178.2c11.5,0,8,0,19.5,0c3.9,0,5.5-1.8,5.5-5.7c0-16.2,0-47.4,0-63.6 c0-3.8,1.8-5.5,5.5-5.5c7.5,0,30,0,37.5,0c2.1,0,3.6-0.8,4.5-2.7s0.3-3.6-1.1-5.1c-1.5-1.7-3.2-3.5-4.7-5.1 c-21-23.1-42.1-46.2-63.1-69.3c-2.4-2.6-5-2.6-7.3,0c-22.5,24.8-45,49.4-67.7,74.1c-1.5,1.5-2.2,3.3-1.2,5.4 c0.9,2,2.6,2.5,4.6,2.5c7.4,0,29.6,0.2,36.9,0c3.3,0,6.1,1.7,6,6c-0.2,16,0,47.1,0,63c0,4.1,1.6,5.7,5.8,5.7 C92.1,178.2,88.5,178.2,99.9,178.2z",
			fill: "currentColor"
		}) }) }) }),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {}),
		/* @__PURE__ */ _jsx("g", {})
	]
});
export { SvgIconHigher as ReactComponent };
